import {
    apiRequest,
    bagianSoalList,
    bagianSoalActive,
    bagianSoalInactive,
    bagianSoalDetail,
    bagianSoalCreate,
    bagianSoalUpdate,
    bagianSoalDelete
} from "../../../../../../services/adapters/master/penialian360Service"

class DataTableRepository {
    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", bagianSoalList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", bagianSoalInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", bagianSoalActive, {
            body: query
        }, true)
    }

    fetchDetail = async (uuid) => {
        return await apiRequest("get", bagianSoalDetail, {
            params: { uuid: uuid }
        }, true)
    }

    fetchCreate = async (data) => {
        return await apiRequest("post", bagianSoalCreate, {
            body: data
        }, true)
    }

    fetchUpdate = async (data) => {
        return await apiRequest("post", bagianSoalUpdate, {
            body: data
        }, true)
    }

    fetchDelete = async (query) => {
        return await apiRequest("post", bagianSoalDelete, {
            body: query
        }, true)
    }
}

export default DataTableRepository
